import { createContext } from 'react';

export type ToastAppearance = 'error' | 'warning' | 'success' | 'info';

export type ToastContextState = {
  showToast: (message: string, type: ToastAppearance) => void;
};

export const ToastContext = createContext<ToastContextState | undefined>(undefined);
